import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { visibleCartCount } from '@theme/custom.cart-visible-count';

/**
 * Header actions component that manages cart notifications.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} liveRegion - The live region for cart announcements.
 *
 * @extends {Component<Refs>}
 */
class HeaderActions extends Component {
  requiredRefs = ['liveRegion'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  /**
   * Handles cart update events and announces the new count to screen readers.
   *
   * The announcement must match the bubble, so it reads the visible count from the cart
   * section first and only falls back to `resource.item_count`, which counts hidden add-on
   * lines (cart-icon.js does the same).
   *
   * @param {CustomEvent<{ resource?: { item_count?: number }, data?: { sections?: Record<string, string> } }>} event
   */
  #onCartUpdate = (event) => {
    const cartCount = visibleCartCount(event.detail.data?.sections) ?? event.detail.resource?.item_count;
    if (cartCount === undefined) return;

    this.refs.liveRegion.textContent = `${Theme.translations.cart_count}: ${cartCount}`;
  };
}

if (!customElements.get('header-actions')) {
  customElements.define('header-actions', HeaderActions);
}
